import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { Table, DatePicker, Button, Input, Select, Tooltip } from 'antd';
import { CloseOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons'

import { 
  getAccessProblemList
} from '../../actions/publish'

const { RangePicker } = DatePicker;
const { Option } = Select;


const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "61px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#3276C3",
      borderRadius: "0 !important",
    },
    container: {
      paddingTop: "20px",
    },
    dateFilter: {
      width: "236px",
      padding: "8px",
    },
    defaultFilter: {
      width: "196px",
      padding: "8px",
    },
    btnLine: {
      marginTop: "8px",
      display: 'flex',
      justifyContent: 'space-between'
    },
    select: {
      width: '100%'
    },
    tableContainer: {
      width: '100%',
      '& .ant-table-cell-row-hover': {
        background: '#f0fbff !important'
      },
      '& td.ant-table-column-sort': {
        background: '#f0fbff !important'
      }
    }
  };
};

class AccessProblem extends Component {
  constructor(props){
    super(props);
  }

  state = {
    loading: true,
    filteredInfo: null,
    filterForm: {},
    filterDropdownVisible: false,
    companyArr: [], // 申请人下拉数据
    dataSourceArr: [], // 数据来源下拉数据
    columns: [],
    data: [],
    updateTime: '',
    searchHistoryList: [],
    form: {},
    defaultForm: { // 默认值
      KeyWord: "",
      ProblemType: "",
      ProblemDescribe: "",
      ReviewDepartment: "",
      ReviewPersonnel: "",
      UpdateTime: [],
      Reply: "",
      getInputFilterOption: "",
      InternalDepartment: "",
      Remarks: "",
    },
    labelObj: { // 筛选项key - label对应关系
      KeyWord: '关键词',
      ProblemType: '问题类型',
      ProblemDescribe: '问题描述',
      ReviewDepartment: '评审部门',
      ReviewPersonnel: '评审人员',
      UpdateTime: '更新时间',
      Reply: '答复',
      getInputFilterOption: '答复策略',
      InternalDepartment: '内部部门',
      Remarks: '备注',
    },
    labelListObj: { },
    selectKeys: [],
    sortObj: {},
    page: {
      PageNo: 1,
      PageSize: 10
    },
    total: 0,
    scrollObj: {
      x: 1560,
      y: 600
    },
    paginationObj: {
      showSizeChanger: true,
      allTotal: 0,
      total: 0,
      showTotal: (total, range) => {
        return '当前已筛选出【' + this.state.paginationObj.total + '】条，总数据量【' + this.state.paginationObj.allTotal + '】条'
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize)
      },
    }
  };

  componentDidMount() {
    // 计算表格高度
    let height = window.innerHeight
    this.setState({
      scrollObj: {
        x: 1560,
        y: height - 266
      }
    })

    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })

    let search = decodeURI(this.props.location.search)
    let params = search.substring(1).split('&')
    let obj = params.find(v => {
      return v.indexOf('keyword=') == 0
    })
    if (obj) {
      let urlKeyword = obj.split('=')[1]
      this.setState({
        form: {
          ...this.state.form,
          KeyWord: urlKeyword,
        },
        showKeys: ['KeyWord']
      }, () => this.initData())
    } else {
      this.initData()
    }
  }

  resetForm = () => {
    this.setState({
      form: {
        KeyWord: "",
        ProblemType: "",
        ProblemDescribe: "",
        ReviewDepartment: "",
        ReviewPersonnel: "",
        UpdateTime: [],
        Reply: "",
        getInputFilterOption: "",
        InternalDepartment: "",
        Remarks: "",
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => this.initData())
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => this.initData())
  }

  searchForm = () => {
    this.initData()
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        let showValue = form[key]
        let label = ''
        if (key == 'UpdateTime') {
          showValue = `${showValue[0].format("YYYY-MM-DD")} - ${showValue[1].format("YYYY-MM-DD")}`
        }
        if (this.state.selectKeys.indexOf(key) > -1) {
          label = this.state[this.state.labelListObj[key]].find(v => {
            return v.ID == showValue
          }).Name
        }
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: label || showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = label || showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    })
  }

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  initData = () => {
    let UpdateTime = this.state.form.UpdateTime
    let param =  Object.assign({}, this.state.form, this.state.page)
    if (UpdateTime && UpdateTime.length > 0) {
      param.UpdateTime_KS = UpdateTime[0].format("YYYY-MM-DD")
      param.UpdateTime_JS = UpdateTime[1].format("YYYY-MM-DD")
    }
    delete(param.UpdateTime)
    getAccessProblemList(param).then(res => {
      if (!res.Error) {
        let newPaginationObj = this.state.paginationObj
        newPaginationObj.total = res.DataNumber
        newPaginationObj.allTotal = res.UnfilteredAllDataNumber
        this.setState({
          data: res.DataList.map(v => {
            v.CorporateName = v.ApplicantCompanyOrApplicantProcessingCompany
            return v
          }),
          paginationObj: newPaginationObj,
          loading: false
        }, () => {
          this.getColumns()
        })
      } else {
        this.setState({
          loading: false
        })
      }
    })
  }


  getColumns = () => {
    let classes = this.props.classes

    let columns = [
      {
        title: '厂商名称',
        dataIndex: 'ManufacturerName',
        key: 'ManufacturerName',
        width: 160,
      },
      {
        title: '问题类型',
        dataIndex: 'ProblemType',
        key: 'ProblemType',
        width: 280,
      },
      {
        title: '问题描述',
        dataIndex: 'ProblemDescribe',
        width: 360,
        key: 'ProblemDescribe',
        ellipsis: {
          showTitle: false,
        },
        render: (_, record) => {
          let content = record.ProblemDescribe || ''
          return   <Tooltip placement="topLeft" title={content}>
            <span >{content}</span>
          </Tooltip>
        },
      },
      {
        title: '评审部门',
        dataIndex: 'ReviewDepartment',
        key: 'ReviewDepartment',
        width: 120,
      },
      {
        title: '评审人员',
        dataIndex: 'ReviewPersonnel',
        width: 150,
        key: 'ReviewPersonnel',
      },
      {
        title: '答复',
        dataIndex: 'Reply',
        width: 330,
        key: 'Reply',
        render: (_, record) => {
          let content = record.Reply || ''
          return   <Tooltip placement="topLeft" title={content}>
            <span >{content.length > 20 ? `${content.substring(0, 20)}...` : content}</span>
          </Tooltip>
        },
      },
      {
        title: 'RA',
        dataIndex: 'Remarks',
        key: 'Remarks',
        width: 160,
      },
    ]

    this.setState({
      columns: columns,
    })
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.getColumns();
        this.initData();
      }
    );
  };


  pageChange = (page, pageSize) => {
    if (page == this.state.page.PageNo && pageSize == this.state.page.PageSize) {
      return
    }
    this.setState({
      page: {
        PageNo: page,
        PageSize: pageSize
      },
      loading: true
    }, () => this.initData())
  }

  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">关键词</div>
              <Input  value={this.state.form.KeyWord}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'KeyWord')} 
                placeholder="请输入关键词"/>
            </div>
            <div className="form-item">
              <div className="form-label">问题类型</div>
              <Input  value={this.state.form.title}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'ProblemType')} 
                placeholder="请输入问题类型"/>
            </div>
            <div className="form-item">
              <div className="form-label">问题描述</div>
              <Input  value={this.state.form.ProblemDescribe}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'ProblemDescribe')} 
                placeholder="请输入问题描述"/>
            </div>
            <div className="form-item">
              <div className="form-label">评审部门</div>
              <Input  value={this.state.form.ReviewDepartment}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'ReviewDepartment')} 
                placeholder="请输入评审部门"/>
            </div>
            <div className="form-item">
              <div className="form-label">评审人员</div>
              <Input  value={this.state.form.ReviewPersonnel}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'ReviewPersonnel')} 
                placeholder="请输入评审人员"/>
            </div>
            <div className="form-item">
              <div className="form-label">更新时间</div>
              <RangePicker
                allowClear
                value={this.state.form.UpdateTime}
                onChange={(value) => this.onChangeForm(value, 'UpdateTime')}
              />
            </div>
            <div className="form-item">
              <div className="form-label">答复</div>
              <Input  value={this.state.form.Reply}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'Reply')} 
                placeholder="请输入答复"/>
            </div>
            <div className="form-item">
              <div className="form-label">答复策略</div>
              <Input  value={this.state.form.getInputFilterOption}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'getInputFilterOption')} 
                placeholder="请输入答复策略"/>
            </div>
            <div className="form-item">
              <div className="form-label">内部部门</div>
              <Input  value={this.state.form.InternalDepartment}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'InternalDepartment')} 
                placeholder="请输入内部部门"/>
            </div>
            <div className="form-item">
              <div className="form-label">备注</div>
              <Input  value={this.state.form.Remarks}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'Remarks')} 
                placeholder="请输入备注"/>
            </div>
           
          </div>

          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>

        <div className="common-main">
          <div className="common-main-search">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">受理前咨询</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
            <Grid container className={classes.container} id="tableContainer">
              <Table 
                className={classes.tableContainer}
                columns={this.state.columns} 
                loading={this.state.loading} 
                dataSource={this.state.data} 
                onChange={this.handleChange} 
                scroll={this.state.scrollObj}
                pagination={this.state.paginationObj}
                bordered
                />
              
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(AccessProblem));
